import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import ReasonType from '../configuration/reasons/ReasonType'
import Reason from '../configuration/reasons/Reason'

const MainReason = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Reasons'),
      component: <Reason />,
      to: '/configuration/picklist/reasons',
      permissionCode: 'REASONS_TAB'
    },
    {
      title: t_('Reason Types'),
      component: <ReasonType />,
      to: '/configuration/picklist/reasonTypes',
      permissionCode: 'REASON_TYPES_TAB'
    }
  ]
  return <SmartNavigator componentsInfo={componentsInfo} />
}
export default MainReason
